import * as React from 'react';
import waitAlertSvg from './assets/wait_alert_illustration.svg';
import { t } from '../utils';
import { Button } from '../Button';
/**
 * @deprecated Komponenten er erstattet av Modal fra "@skatteetaten/ds-overlays"
 *
 * visibleName WaitAlert
 */

const WaitAlert = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: 'wait-alert-content'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'wait-alert-svg',
    src: waitAlertSvg,
    alt: t('dialog.waitAlert.alt')
  }), props.children ? props.children : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "heading",
    id: 'waitAlertHeading',
    className: 'wait-alert-heading',
    "aria-level": 1
  }, t('dialog.waitAlert.title')), /*#__PURE__*/React.createElement("p", {
    id: 'waitAlertText'
  }, t('dialog.waitAlert.paragraph'))), /*#__PURE__*/React.createElement(Button, {
    buttonStyle: "primary",
    className: 'wait-alert-btn',
    onClick: () => {
      props.onDismiss && props.onDismiss();
    }
  }, props.waitAlertBtnText ? props.waitAlertBtnText : t('dialog.waitAlert.button_text')));
};

export default WaitAlert;